import React from 'react';
import { connect } from 'react-redux';
import * as Yup from 'yup';
import { Formik, Form, Field } from 'formik';
import { injectIntl } from 'react-intl';
import { PropTypes } from 'prop-types';

import { UndoOutlined, PlayCircleOutlined } from '@ant-design/icons';

import { Button, Row, Col, Typography } from 'antd';
import {
  FormikTransfer,
  FormikDatePicker,
  FormikSelect,
  FormikButton
} from '../../Components/Formik';
import LspSlsOrdTrackingReportActions from '../../Stores/LspSlsOrdTrackingReport/Actions';

const { Text } = Typography;

class CriteriaForm extends React.PureComponent {
  constructor() {
    super();

    this.handleSearchDivision = this.handleSearchDivision.bind(this);
    this.handleSearchDeliveryPoint = this.handleSearchDeliveryPoint.bind(this);
    this.handleSearchDebtor = this.handleSearchDebtor.bind(this);
    this.handleSearchTransport = this.handleSearchTransport.bind(this);
  }

  componentDidMount() {}

  componentDidUpdate() {}

  componentWillUnmount() {}

  handleSearchDivision(form, value) {
    const { fetchDivisionOptions } = this.props;

    fetchDivisionOptions(value);
  }

  handleSearchDeliveryPoint(form, value) {
    const { fetchDeliveryPointOptions } = this.props;

    fetchDeliveryPointOptions(value);
  }

  handleSearchDebtor(form, value) {
    const { fetchDebtorOptions } = this.props;

    fetchDebtorOptions(value);
  }

  handleSearchTransport(form, value) {
    const { fetchTransportOptions } = this.props;

    fetchTransportOptions(value);
  }

  render() {
    const {
      intl,
      criteria,
      reportIsLoading,
      lspSlsOrdTracking,
      divisionOptions,
      divisionIsLoading,
      deliveryPointOptions,
      deliveryPointIsLoading,
      debtorOptions,
      debtorIsLoading,
      transportOptions,
      transportIsLoading
    } = this.props;

    return (
      <Formik
        enableReinitialize
        initialValues={criteria}
        onSubmit={(values, formikBag) => {
          lspSlsOrdTracking(formikBag, values);
        }}
        validationSchema={Yup.object().shape({
          doc_date: Yup.date().min(
            new Date(1969, 12, 1),
            intl.formatMessage({ id: 'doc_date_is_required' })
          )
        })}
      >
        {({
          // values,
          // handleChange,
          // errors,
          // setFieldTouched,
          dirty,
          // touched,
          isSubmitting,
          // isValid,
          handleSubmit,
          handleReset
        }) => (
          <Form>
            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'start_date' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field
                  name="start_date"
                  component={FormikDatePicker}
                  disabled={isSubmitting || reportIsLoading}
                />
              </Col>
            </Row>

            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'end_date' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field
                  name="end_date"
                  component={FormikDatePicker}
                  disabled={isSubmitting || reportIsLoading}
                />
              </Col>
            </Row>

            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'division' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field
                  name="division_ids_select2"
                  component={FormikSelect}
                  showArrow
                  filterOption={false}
                  onSearch={this.handleSearchDivision}
                  notFoundContent={null}
                  loading={divisionIsLoading}
                  options={divisionOptions}
                  disabled={isSubmitting || reportIsLoading}
                  selectMode="multiple"
                />
              </Col>
            </Row>

            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'delivery_point' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field
                  name="delivery_point_ids_select2"
                  component={FormikSelect}
                  showArrow
                  filterOption={false}
                  onSearch={this.handleSearchDeliveryPoint}
                  notFoundContent={null}
                  loading={deliveryPointIsLoading}
                  options={deliveryPointOptions}
                  disabled={isSubmitting || reportIsLoading}
                  selectMode="multiple"
                />
              </Col>
            </Row>

            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'principal' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field
                  name="debtor_ids_select2"
                  component={FormikSelect}
                  showArrow
                  filterOption={false}
                  onSearch={this.handleSearchDebtor}
                  notFoundContent={null}
                  loading={debtorIsLoading}
                  options={debtorOptions}
                  disabled={isSubmitting || reportIsLoading}
                  selectMode="multiple"
                />
              </Col>
            </Row>

            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={3}>
                <Text>{intl.formatMessage({ id: 'transport' })}</Text>
              </Col>
              <Col span={1}>
                <Text>:</Text>
              </Col>
              <Col span={20}>
                <Field
                  name="transport_ids_select2"
                  component={FormikSelect}
                  showArrow
                  filterOption={false}
                  onSearch={this.handleSearchTransport}
                  notFoundContent={null}
                  loading={transportIsLoading}
                  options={transportOptions}
                  disabled={isSubmitting || reportIsLoading}
                  selectMode="multiple"
                />
              </Col>
            </Row>

            <Row type="flex" justify="center" gutter={[8, 8]}>
              <Col span={24}>
                <Field
                  name="columns"
                  component={FormikTransfer}
                  intl={intl}
                  disabled={isSubmitting || reportIsLoading}
                />
              </Col>
            </Row>

            <Row type="flex" justify="space-between" gutter={[0, 16]}>
              <Col span={24}>
                <Button
                  disabled={!dirty}
                  loading={isSubmitting || reportIsLoading}
                  onClick={handleReset}
                  icon={<UndoOutlined />}
                  type="primary"
                >
                  {intl.formatMessage({ id: 'reset' })}
                </Button>
                <Field
                  name="submit_action"
                  value="run_report"
                  component={FormikButton}
                  loading={isSubmitting || reportIsLoading}
                  onClick={handleSubmit}
                  label={intl.formatMessage({
                    id: 'run_report'
                  })}
                  icon={<PlayCircleOutlined />}
                  type="primary"
                />
              </Col>
            </Row>
          </Form>
        )}
      </Formik>
    );
  }
}

CriteriaForm.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  intl: PropTypes.object,

  // eslint-disable-next-line react/forbid-prop-types
  criteria: PropTypes.object,
  reportIsLoading: PropTypes.bool,
  lspSlsOrdTracking: PropTypes.func,
  fetchDivisionOptions: PropTypes.func,
  fetchDeliveryPointOptions: PropTypes.func,
  fetchDebtorOptions: PropTypes.func,
  fetchTransportOptions: PropTypes.func,

  divisionOptions: PropTypes.arrayOf(PropTypes.object),
  divisionIsLoading: PropTypes.bool,

  deliveryPointOptions: PropTypes.arrayOf(PropTypes.object),
  deliveryPointIsLoading: PropTypes.bool,

  debtorOptions: PropTypes.arrayOf(PropTypes.object),
  debtorIsLoading: PropTypes.bool,

  transportOptions: PropTypes.arrayOf(PropTypes.object),
  transportIsLoading: PropTypes.bool
};

CriteriaForm.defaultProps = {
  intl: {},

  criteria: {},
  reportIsLoading: false,
  lspSlsOrdTracking() {},
  fetchDivisionOptions() {},
  fetchDeliveryPointOptions() {},
  fetchDebtorOptions() {},
  fetchTransportOptions() {},

  divisionOptions: [],
  divisionIsLoading: false,

  deliveryPointOptions: [],
  deliveryPointIsLoading: false,

  debtorOptions: [],
  debtorIsLoading: false,

  transportOptions: [],
  transportIsLoading: false
};

const mapStateToProps = state => ({
  timestamp: state.lspSlsOrdTrackingReport.timestamp,
  criteria: state.lspSlsOrdTrackingReport.criteria,

  reportIsLoading: state.lspSlsOrdTrackingReport.reportIsLoading,

  divisionOptions: state.lspSlsOrdTrackingReport.divisionOptions,
  divisionIsLoading: state.lspSlsOrdTrackingReport.divisionIsLoading,

  deliveryPointOptions: state.lspSlsOrdTrackingReport.deliveryPointOptions,
  deliveryPointIsLoading: state.lspSlsOrdTrackingReport.deliveryPointIsLoading,

  debtorOptions: state.lspSlsOrdTrackingReport.debtorOptions,
  debtorIsLoading: state.lspSlsOrdTrackingReport.debtorIsLoading,

  transportOptions: state.lspSlsOrdTrackingReport.transportOptions,
  transportIsLoading: state.lspSlsOrdTrackingReport.transportIsLoading
});

const mapDispatchToProps = dispatch => ({
  lspSlsOrdTracking: (formikBag, criteria) =>
    dispatch(
      LspSlsOrdTrackingReportActions.lspSlsOrdTrackingReportLspSlsOrdTracking(formikBag, criteria)
    ),

  fetchDivisionOptions: search =>
    dispatch(LspSlsOrdTrackingReportActions.lspSlsOrdTrackingReportFetchDivisionOptions(search)),
  fetchDeliveryPointOptions: search =>
    dispatch(
      LspSlsOrdTrackingReportActions.lspSlsOrdTrackingReportFetchDeliveryPointOptions(search)
    ),
  fetchDebtorOptions: search =>
    dispatch(LspSlsOrdTrackingReportActions.lspSlsOrdTrackingReportFetchDebtorOptions(search)),
  fetchTransportOptions: search =>
    dispatch(LspSlsOrdTrackingReportActions.lspSlsOrdTrackingReportFetchTransportOptions(search))
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CriteriaForm));
